import { render, staticRenderFns } from "./a-table.vue?vue&type=template&id=0c4bde0a&scoped=true&"
import script from "./a-table.vue?vue&type=script&lang=js&"
export * from "./a-table.vue?vue&type=script&lang=js&"
import style0 from "./a-table.vue?vue&type=style&index=0&id=0c4bde0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4bde0a",
  null
  
)

export default component.exports